<nav id="main-side-nav" class="header navbar navbar-expand-lg navbar-light"
  (mouseleave)="hoveredItemIndex = navigationMenu.length">
  <div class="screen-overlay">
    <div class="navbar-collapse expanded">
      <ul class="navbar-nav">
        <li class="nav-item logo-container nav-divider" [ngStyle]="{ 'text-align': 'unset' }">
          <span class="nav-link logo d-flex w-100">
            <div class="brand-panel">
              <a class="navbar-brand" [routerLink]="['/dashboard']">
                <img [src]="'/assets/images/logo.svg'" alt="logo" class="brand-logo-img logo-expanded" />
              </a>
            </div>
          </span>
        </li>
        <li class="nav-section-label">Workspace</li>
        <ng-container *ngFor="let menu of navigationMenu; let i = index">
          <li #rla="routerLinkActive" [routerLinkActive]="['active-list']" class="nav-item menu-container main-list"
            [ngStyle]="{ 'text-align': 'unset' }" placement="right">
            <a [routerLink]="[menu.routerLink]" class="nav-link overflow-hidden" (mouseenter)="hoveredItemIndex = i">
              <div class="item-container menu-item mp-10" [ngClass]="{ active: rla.isActive }">
                <span class="active-indicator"></span>
                <div class="item">
                  <div class="item-logo">
                    <img [src]="menu.icon" alt="{{ menu.title }}" />
                  </div>
                  <div class="item-details">
                    <div class="main-menu-title">
                      {{ menu.title }}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</nav>
